import { UserRoles } from '@dynamika-shared/types/auth';
import { routesPath } from '@router/routes';

//Config for left side menu
export const menuOptions = {
  dashboard: {
    title: 'Control Tower',
    name: 'dashboard',
    path: routesPath.dashboard,
    icon: 'dashboard',
    disabled: true,
  },
  clinicalTrials: {
    title: 'Clinical Trials',
    name: 'clinicalTrials',
    path: routesPath.clinicalTrials,
    icon: 'clinicalTrials',
  },
  inventory: {
    title: 'Inventory',
    name: 'inventory',
    path: routesPath.inventory,
    icon: 'inventory',
    disabled: true,
    children: [
      {
        title: 'Sponsors',
        name: 'sponsors',
        path: routesPath.sponsors,
        disabled: true,
      },
      {
        title: 'Sites',
        name: 'sites',
        path: routesPath.sites,
        disabled: true,
      },
      {
        title: 'Modalities',
        name: 'modalities',
        path: routesPath.modalities,
        disabled: true,
      },
      {
        title: 'Labels',
        name: 'labels',
        path: routesPath.labels,
        disabled: true,
      },
      {
        title: 'Therapeutic Area',
        name: 'therapeuticArea',
        path: routesPath.therapeuticArea,
        disabled: true,
      },
      {
        title: 'Disease',
        name: 'disease',
        path: routesPath.disease,
        disabled: true,
      },
      {
        title: 'Body Location',
        name: 'bodyLocation',
        path: routesPath.bodyLocation,
        disabled: true,
      },
    ],
  },
  usersAndLogs: {
    title: 'User & Logs',
    name: 'userAndLogs',
    path: routesPath.usersAndLogsUsers,
    icon: 'users',
  },
  qc: {
    title: 'QC',
    name: 'qc',
    path: routesPath.qc,
    icon: 'qc',
  },
  subjects: {
    title: 'Subject list',
    name: 'subject',
    path: routesPath.subjectBase,
    icon: 'subjects',
  },
  validationSpecialist: {
    title: 'Validation Specialist',
    name: 'validationSpecialist',
    path: routesPath.validationSpecialistSubjects,
    icon: 'validationSpecialist',
  },
  profile: {
    title: 'Profile',
    name: 'profile',
    path: routesPath.profile,
    icon: 'users',
  },
  // TODO: add audit trials to sponsor roles when back will be ready
  // auditTrials: {
  //   title: 'Audit Trails',
  //   name: 'auditTrials',
  //   path: routesPath.sponsorsAuditClinicalTrials,
  //   icon: 'auditTrials',
  // },
  reader: {
    title: 'Readings',
    name: 'readings',
    path: routesPath.reader,
    icon: 'qc',
  },
  scoringFormEditor: {
    title: 'Scoring Form Editor',
    name: 'scoringFormEditor',
    path: routesPath.localhostScoringForm,
    icon: 'inventory',
  },
};

export type MenuConfig = {
  title: string;
  name: string;
  path: string;
  icon?: string;
  children?: MenuConfig[];
  disabled?: boolean;
};

export const menuConfig: Record<UserRoles, MenuConfig[]> = {
  [UserRoles.ADMIN]: [
    menuOptions.dashboard,
    menuOptions.clinicalTrials,
    menuOptions.inventory,
    menuOptions.usersAndLogs,
  ],
  [UserRoles.PROJECT_MANAGER]: [
    menuOptions.dashboard,
    menuOptions.clinicalTrials,
    menuOptions.inventory,
    menuOptions.usersAndLogs,
  ],
  [UserRoles.SUPPORT]: [
    menuOptions.clinicalTrials,
  ],
  [UserRoles.SITE]: [menuOptions.subjects],
  [UserRoles.IMAGING_SPECIALIST]: [menuOptions.qc],
  [UserRoles.READER]: [menuOptions.reader],
  [UserRoles.USER]: [],
  [UserRoles.DATA_MANAGER]: [menuOptions.profile],
  [UserRoles.SPONSOR]: [
    { ...menuOptions.dashboard, disabled: false },
    menuOptions.inventory,
    
    // TODO: add audit trials to sponsor roles when back will be ready
    // menuOptions.auditTrials,
  ],
  [UserRoles.EXTERNAL_USER]: [menuOptions.subjects],
  [UserRoles.VALIDATION_SPECIALIST]: [menuOptions.validationSpecialist],
};

if (location.hostname === 'localhost') {
  menuConfig[UserRoles.ADMIN].push(menuOptions.scoringFormEditor);
}
